import * as AWS from 'aws-sdk/global';
import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import config from '../config';
import TokenService from './storage.service';
import ApiService from './api.service';

import { Auth, API } from "aws-amplify";


const poolData = {
  UserPoolId : process.env.VUE_APP_COGNITO_USERPOOL_ID,
  ClientId : process.env.VUE_APP_CLIENT_ID
};

const UserService = {
  signup (data) {
    const { username, email, password } = data;

    return new Promise((resolve, reject) => {
      Auth.signUp({
        username,
        password,
        attributes: {
          email: username
        }
      })
      .then(result => resolve(result.user))
      .catch(err => reject(err))
    });
  },
  verify(data) {
    const { username, password, code } = data;

    return new Promise((resolve, reject) => {
      Auth.confirmSignUp(username, code, {
        forceAliasCreation: true    
      })
      .then(result => resolve(this.signin({ username: username, password: password })))
      .catch(err => reject(err));
    });
  },
  async signin(data) {
    const { username, password } = data;

    return new Promise((resolve, reject) => {
      Auth.signIn(username, password)
      .then(result => {
        const idToken = result.signInUserSession.idToken.jwtToken;
        const sub = result.attributes.sub; 

        TokenService.saveToken("idToken", idToken);
        TokenService.saveToken("sub", sub);
        TokenService.saveToken('templatesSortingType', "Newest top");
        TokenService.saveToken('privateTemplatesSortingType', "Newest top");
        TokenService.saveToken('environmentsSortingType', "Newest top");
        ApiService.setHeader();

        resolve({
          idToken,
          groups: result.signInUserSession.idToken.payload['cognito:groups']
        });

      })
      .catch(err => reject(err))

    });
  },
  async checkIfAuthenticated() {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
      .then(result => {
        const idToken = result.signInUserSession.idToken.jwtToken;
        const sub = result.attributes.sub; 

        TokenService.saveToken("idToken", idToken);
        TokenService.saveToken("sub", sub);

        resolve({
          isAuth: true,
          groups: result.signInUserSession.idToken.payload['cognito:groups']
        });
      })
      .catch(err => reject('User is not authenticated!'))
    })
  },
  signOut() {
    return new Promise((resolve, reject) => {
      Auth.signOut()
      .then(result => {
        TokenService.removeToken("idToken");
        TokenService.removeToken("sub");
        TokenService.removeToken("templatesSortingType");
        TokenService.removeToken('privateTemplatesSortingType');
        TokenService.removeToken("environmentsSortingType");
        resolve({ loggedOut: true });
      })
      .catch(err => reject(err))
    });
  },
  resendConfirmationCode(username) {
    return new Promise((resolve, reject) => {
      Auth.resendSignUp(username)
      .then(result => resolve(result))
      .catch(err => reject(err))
    })
  },
  // TODO: Amplify
  refreshToken() {
    const userPool = new CognitoUserPool(poolData);
    const currentUser = userPool.getCurrentUser();

    return new Promise((resolve, reject) => {
      currentUser.getSession((err, session) => {
        currentUser.refreshSession(session.getRefreshToken(), (err, session) => {
          if (err) {
            reject();
          } else {
            TokenService.saveToken("idToken", session.getIdToken().getJwtToken());
            TokenService.saveToken("sub", session.getIdToken().payload.sub);
            ApiService.setHeader();
            resolve(session.getIdToken().getJwtToken());
          }
        });
      });
    })
  },
  getUserEmailAddress() {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
      .then(result => {
        const email = result.attributes.email; 
        resolve(email);
      })
      .catch(err => reject(err))
    })
  },
  forgotPassword(data) {
    return new Promise((resolve, reject) => {
      Auth.forgotPassword(data)
      .then(result => resolve(result))
      .catch(error => reject(error))
    });
  },
  forgotPasswordSubmit(data) {
    const { email, password, code } = data;

    return new Promise((resolve, reject) => {
      Auth.forgotPasswordSubmit(email, code, password)
      .then(result => resolve(result))
      .catch(error => reject(error))
    });
  }
}

export default UserService;
